import BaseService from '../BaseService'
import axios from "axios";

class NotificationService extends BaseService {
    constructor() {
        super('/notifications');
    }

    markAsRead() {
        return axios.post(`${this.resource}/mark-as-read?notificationOff`)
    }
}


export default new NotificationService()
